import gql from "graphql-tag";
import { Employee } from "../baseTypes";
export default gql`
  query GetEmployee($locationId: ID!, $identifier: String!) {
    getEmployee(locationId: $locationId, insuranceNumber: $identifier) {
      birthdate
      identifier
      insuranceNumber
      locationId
      expiresAt
      location {
        id
        name
        locationId

      }
      address {
        street
        city
        zip
        number
      }
      patient {
        email
        insuranceNumber
        firstname
        lastname
      }
    }
  }
`;
export interface GetEmployeeQuery {
  getEmployee: Employee | null;
}
